import moduleProjects from './projects';
import moduleFolders from './folders';
import moduleItems from './items';
import moduleVersions from './versions';

export default {
  namespaced: true,
  modules: {
    projects: moduleProjects,
    folders: moduleFolders,
    items: moduleItems,
    versions: moduleVersions,
  },
};
